<template>
  <div class="radio_container required err_message_box">
    <p>
      <span class="txt-red txt-regular" v-if="item.required">* </span>
      {{ item.label }}
    </p>
    <span class="err_message txt-red small">{{errorMsg}}</span>
    <label
      v-for="(option, index) in item.options"
      :key="`option_${index}`"
      class="p"
    >
      <input
        :id="`${item.name}_${index}`"
        :class="{
          readonly: readonly,
          isChosen: value == option.value
        }"
        :checked="value == option.value"
        type="radio"
        :name="item.name"
        :value="option.value"
        :error="error"
        @change="test(); $emit('input', option.value)"
      >
{{ option.name }}
      <div class="checkmark"></div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'FormRadio',
  props: [
    'value',
    'item',
    'readonly',
    'chosen',
  ],
  data() {
    return {
      errorMsg: '',
    };
  },
  methods: {
    test() {
      this.errorMsg = (this.value === null || this.value === undefined || this.value === '') ? '請至少選擇一項' : '';
    },
  },
  computed: {
    error() {
      if (this.errorMsg !== '') {
        return true;
      }
      return false;
    },
  },
  watch: {
    value() {
      if (this.value === null || this.value === undefined || this.value === '') {
        this.errorMsg = '請至少選擇一項';
      } else {
        this.errorMsg = '';
      }
    },
  },
};
</script>
